import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, CardMedia, IconButton, useTheme } from '@mui/material';
import './SquareMiddlePrice.scss';

interface SquareMiddlePriceProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  onClick?: () => void;
}

const SquareMiddlePrice = ({
  title,
  description,
  price,
  image,
  onClick,
}: Partial<SquareMiddlePriceProps>) => {
  const theme = useTheme();

  return (
    <ButtonBase
      className="dish dish--column-free"
      onClick={onClick}
      component="div"
    >
      {image ? (
        <CardMedia
          className="dish__image"
          component={'img'}
          title={title}
          image={image}
        />
      ) : null}

      <div className="dish__body">
        <h3 className="dish__title">{title}</h3>
        <p className="dish__price">{price}</p>
        <p className="dish__description">{description}</p>

        <div className="dish__actions">
          <IconButton
            className="dish__btn-details"
            onClick={onClick}
            sx={{ backgroundColor: theme.palette.primary.main }}
          >
            <HugeiconsIcon icon={Add01Icon} className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};

export default SquareMiddlePrice;
